/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AgentCompatibilityAreaEnum from './AgentCompatibilityAreaEnum';
import AgentCompatibilityAssetPresetEnum from './AgentCompatibilityAssetPresetEnum';
import AgentCompatibilityProfile from './AgentCompatibilityProfile';
import AgentCompatibilityPropertyTypeEnum from './AgentCompatibilityPropertyTypeEnum';
import AgentCompatibilitySupportLevelEnum from './AgentCompatibilitySupportLevelEnum';
import MoneyAmount from './MoneyAmount';

/**
 * The AgentCompatibilityProfileRequest model module.
 * @module model/AgentCompatibilityProfileRequest
 * @version 1.0.0
 */
class AgentCompatibilityProfileRequest {
    /**
     * Constructs a new <code>AgentCompatibilityProfileRequest</code>.
     * @alias module:model/AgentCompatibilityProfileRequest
     * @implements module:model/AgentCompatibilityProfile
     */
    constructor() { 
        AgentCompatibilityProfile.initialize(this);
        AgentCompatibilityProfileRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentCompatibilityProfileRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentCompatibilityProfileRequest} obj Optional instance to populate.
     * @return {module:model/AgentCompatibilityProfileRequest} The populated <code>AgentCompatibilityProfileRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentCompatibilityProfileRequest();
            AgentCompatibilityProfile.constructFromObject(data, obj);

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('supported_property_types')) {
                obj['supported_property_types'] = ApiClient.convertToType(data['supported_property_types'], [AgentCompatibilityPropertyTypeEnum]);
            }
            if (data.hasOwnProperty('primary_property_type')) {
                obj['primary_property_type'] = AgentCompatibilityPropertyTypeEnum.constructFromObject(data['primary_property_type']);
            }
            if (data.hasOwnProperty('primary_annual_income')) {
                obj['primary_annual_income'] = ApiClient.convertToType(data['primary_annual_income'], 'Number');
            }
            if (data.hasOwnProperty('supported_annual_income_min')) {
                obj['supported_annual_income_min'] = ApiClient.convertToType(data['supported_annual_income_min'], 'Number');
            }
            if (data.hasOwnProperty('supported_annual_income_max')) {
                obj['supported_annual_income_max'] = ApiClient.convertToType(data['supported_annual_income_max'], 'Number');
            }
            if (data.hasOwnProperty('primary_asset_band')) {
                obj['primary_asset_band'] = MoneyAmount.constructFromObject(data['primary_asset_band']);
            }
            if (data.hasOwnProperty('supported_asset_preset')) {
                obj['supported_asset_preset'] = AgentCompatibilityAssetPresetEnum.constructFromObject(data['supported_asset_preset']);
            }
            if (data.hasOwnProperty('beginner_support_level')) {
                obj['beginner_support_level'] = AgentCompatibilitySupportLevelEnum.constructFromObject(data['beginner_support_level']);
            }
            if (data.hasOwnProperty('experienced_support_level')) {
                obj['experienced_support_level'] = AgentCompatibilitySupportLevelEnum.constructFromObject(data['experienced_support_level']);
            }
            if (data.hasOwnProperty('primary_area')) {
                obj['primary_area'] = AgentCompatibilityAreaEnum.constructFromObject(data['primary_area']);
            }
            if (data.hasOwnProperty('supported_areas')) {
                obj['supported_areas'] = ApiClient.convertToType(data['supported_areas'], [AgentCompatibilityAreaEnum]);
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentCompatibilityProfileRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentCompatibilityProfileRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['supported_property_types'])) {
            throw new Error("Expected the field `supported_property_types` to be an array in the JSON data but got " + data['supported_property_types']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['supported_areas'])) {
            throw new Error("Expected the field `supported_areas` to be an array in the JSON data but got " + data['supported_areas']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AgentCompatibilityProfileRequest.prototype['id'] = undefined;

/**
 * @member {Number} agent_id
 */
AgentCompatibilityProfileRequest.prototype['agent_id'] = undefined;

/**
 * @member {Array.<module:model/AgentCompatibilityPropertyTypeEnum>} supported_property_types
 */
AgentCompatibilityProfileRequest.prototype['supported_property_types'] = undefined;

/**
 * @member {module:model/AgentCompatibilityPropertyTypeEnum} primary_property_type
 */
AgentCompatibilityProfileRequest.prototype['primary_property_type'] = undefined;

/**
 * 主力年収（万円）
 * @member {Number} primary_annual_income
 */
AgentCompatibilityProfileRequest.prototype['primary_annual_income'] = undefined;

/**
 * 対応可年収レンジ下限（万円）
 * @member {Number} supported_annual_income_min
 */
AgentCompatibilityProfileRequest.prototype['supported_annual_income_min'] = undefined;

/**
 * 対応可年収レンジ上限（万円）
 * @member {Number} supported_annual_income_max
 */
AgentCompatibilityProfileRequest.prototype['supported_annual_income_max'] = undefined;

/**
 * @member {module:model/MoneyAmount} primary_asset_band
 */
AgentCompatibilityProfileRequest.prototype['primary_asset_band'] = undefined;

/**
 * @member {module:model/AgentCompatibilityAssetPresetEnum} supported_asset_preset
 */
AgentCompatibilityProfileRequest.prototype['supported_asset_preset'] = undefined;

/**
 * @member {module:model/AgentCompatibilitySupportLevelEnum} beginner_support_level
 */
AgentCompatibilityProfileRequest.prototype['beginner_support_level'] = undefined;

/**
 * @member {module:model/AgentCompatibilitySupportLevelEnum} experienced_support_level
 */
AgentCompatibilityProfileRequest.prototype['experienced_support_level'] = undefined;

/**
 * @member {module:model/AgentCompatibilityAreaEnum} primary_area
 */
AgentCompatibilityProfileRequest.prototype['primary_area'] = undefined;

/**
 * @member {Array.<module:model/AgentCompatibilityAreaEnum>} supported_areas
 */
AgentCompatibilityProfileRequest.prototype['supported_areas'] = undefined;

/**
 * @member {Date} created_at
 */
AgentCompatibilityProfileRequest.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AgentCompatibilityProfileRequest.prototype['updated_at'] = undefined;


// Implement AgentCompatibilityProfile interface:
/**
 * @member {Number} id
 */
AgentCompatibilityProfile.prototype['id'] = undefined;
/**
 * @member {Number} agent_id
 */
AgentCompatibilityProfile.prototype['agent_id'] = undefined;
/**
 * @member {Array.<module:model/AgentCompatibilityPropertyTypeEnum>} supported_property_types
 */
AgentCompatibilityProfile.prototype['supported_property_types'] = undefined;
/**
 * @member {module:model/AgentCompatibilityPropertyTypeEnum} primary_property_type
 */
AgentCompatibilityProfile.prototype['primary_property_type'] = undefined;
/**
 * 主力年収（万円）
 * @member {Number} primary_annual_income
 */
AgentCompatibilityProfile.prototype['primary_annual_income'] = undefined;
/**
 * 対応可年収レンジ下限（万円）
 * @member {Number} supported_annual_income_min
 */
AgentCompatibilityProfile.prototype['supported_annual_income_min'] = undefined;
/**
 * 対応可年収レンジ上限（万円）
 * @member {Number} supported_annual_income_max
 */
AgentCompatibilityProfile.prototype['supported_annual_income_max'] = undefined;
/**
 * @member {module:model/MoneyAmount} primary_asset_band
 */
AgentCompatibilityProfile.prototype['primary_asset_band'] = undefined;
/**
 * @member {module:model/AgentCompatibilityAssetPresetEnum} supported_asset_preset
 */
AgentCompatibilityProfile.prototype['supported_asset_preset'] = undefined;
/**
 * @member {module:model/AgentCompatibilitySupportLevelEnum} beginner_support_level
 */
AgentCompatibilityProfile.prototype['beginner_support_level'] = undefined;
/**
 * @member {module:model/AgentCompatibilitySupportLevelEnum} experienced_support_level
 */
AgentCompatibilityProfile.prototype['experienced_support_level'] = undefined;
/**
 * @member {module:model/AgentCompatibilityAreaEnum} primary_area
 */
AgentCompatibilityProfile.prototype['primary_area'] = undefined;
/**
 * @member {Array.<module:model/AgentCompatibilityAreaEnum>} supported_areas
 */
AgentCompatibilityProfile.prototype['supported_areas'] = undefined;
/**
 * @member {Date} created_at
 */
AgentCompatibilityProfile.prototype['created_at'] = undefined;
/**
 * @member {Date} updated_at
 */
AgentCompatibilityProfile.prototype['updated_at'] = undefined;




export default AgentCompatibilityProfileRequest;

